import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { LabTestCategoryUrl } from '../../../shared/urls/master-data.labtest-category.url';
import { LabTestUrl } from '../../../shared/urls/master-data.labtest.url';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { Utility } from '../../../common/utility'
import { Observable } from 'rxjs/Observable';
@Injectable()
export class LabTestsService {
  constructor(private baseService: BaseService) {

  }

  getConsultationLabTests(consultationId): any {
    let url = Utility.stringFormat(ConsultationUrl.GET_SELECTED_PATIENT_LABTEST, [consultationId]);
    return this.baseService.getData(url);
  }

  getLabTestsCategories(): any {
    let url = LabTestCategoryUrl.LABTESTCATEGORY_GET_DROP_DOWN_LIST;
    return this.baseService.getData(url);
  }

  getLabTests(categoryId): any {
    let url = Utility.stringFormat(LabTestUrl.LABTEST_GET_CENTRE, [categoryId]);
    return this.baseService.getData(url, { isHasPrice: true });
    // let temp = [];
    // data.forEach(datum => {
    //   if (datum.categoryId === categoryId) {
    //     temp.push(datum);
    //   }
    // });
    // return temp;
  }

  updateConsultationLabTests(consultationId, data, isMoveNextStep, isFromConsultationHistory = false): any {
    let url = Utility.stringFormat(ConsultationUrl.GET_PATIENT_LABTEST, [consultationId]);
    url += '?isMoveNextStep=' + isMoveNextStep;
    if (isFromConsultationHistory) {
      url += "&isFromConsultationHistory=" + isFromConsultationHistory;
    }
    return this.baseService.postData(url, data);
  }

  // updatePrescriptions(consultationId, data) {
  //   const url = ConsultationUrl.UPDATE_MEDICAL_CONDITION.replace('{consultationId}', consultationId);
  //   return this.baseService.postData(url, data);
  // }

  quickSearchLabTest(searchKey, showPinner = true) {
    const param = {
      name: searchKey,
      isHasPrice: true
    };
    const url = LabTestUrl.LABTEST_GET_BY_NAME;
    return this.baseService.getData(url, param, showPinner);
  }
}






// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/lab-tests/lab-tests.service.ts